export const transformData = (data) => {
  return {
    id: data?.id ?? '',
    name: data?.first_name + data?.last_name ?? '',
    email: data?.email ?? '',
    engagementScore: data?.engagement_score ?? '-',
    openStatus: data?.open_status ?? '-',
  };
};
